import apiFetch from '../apiFetch'

export default function (token, processingAgencyOrganizedUnitConfig, processAgencyCommunicationServiceId) {
  return apiFetch({ endPoint: `ProcessingAgencyOrganizedUnitConfigs/${processingAgencyOrganizedUnitConfig.ProcessingAgencyOrganizedUnitConfigId}/${processAgencyCommunicationServiceId}`, method: 'PUT', body: processingAgencyOrganizedUnitConfig, token: token })
}
